var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tag === 'a')?_c('a',{attrs:{"target":"_blank","href":_vm.href}},[_vm._t("default")],2):_c(_vm.tag,{tag:"component",staticClass:"prevent-link"},[_c('a',{attrs:{"target":"_blank","href":_vm.href}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }